import { ORDER_APIS } from "@/api_framework/api_config";
import { IOrderManagementStatsFilterBody, IOrderManagementStatsResponse } from "@/api_framework/api_modals/Orders";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setOrderStats } from "@/app_redux/reducers/slices/auth/order_management_slice";
import axios from "axios";
import { useCallback, useRef } from "react";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useOrderManagementStatsAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const controllerRef = useRef<AbortController | null>(null);

  const execute = useCallback(
    async (filterBody: IOrderManagementStatsFilterBody) => {
      dispatch(
        setLoading({
          key: "isQcOrderStatsLoadingInProgress",
          status: true,
        }),
      );

      try {
        // Cancel previous request if exists
        if (controllerRef.current) {
          controllerRef.current.abort();
        }

        controllerRef.current = new AbortController();

        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response = await axios.post<IOrderManagementStatsResponse>(
          ORDER_APIS?.ORDER_STATS?.baseURL ?? "",
          filterBody,
          {
            headers: {
              Authorization: accessToken ?? "",
              "Content-Type": "application/json",
            },
            signal: controllerRef.current.signal,
          },
        );

        if (response.data.status) {
          dispatch(
            setOrderStats({
              data: response.data.data,
            }),
          );
        }
      } catch (error: any) {
        // Ignore aborted requests
        if (error.name === "CanceledError" || error.name === "AbortError") {
          console.log("Request aborted");
          return;
        }

        if (axios.isAxiosError(error)) {
          sendCurl(error.config?.["curlCommand"]);
        }
      } finally {
        dispatch(
          setLoading({
            key: "isQcOrderStatsLoadingInProgress",
            status: false,
          }),
        );
      }
    },
    [dispatch, configuration],
  );

  return execute;
};
